export default {
    main: "#AC8F00",
    navText: "rgba(0, 0, 0, 0.5)"
}
